// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  TradingPair,
  Ratio,
} from "./types";


export default __t.row({
  key: __t.string().primaryKey(),
  get tradingPair() {
    return TradingPair.name("trading_pair");
  },
  get takerFee() {
    return Ratio.name("taker_fee");
  },
  get makerFee() {
    return Ratio.name("maker_fee");
  },
});
